export default __webpack_public_path__ + "static/media/Flames of Despair.d074080b.png";